import React, { useState } from "react";
import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  TextField,
} from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { connect } from "react-redux";
import { updateTrainingDates } from "../../../store/training/actions";
import { showError } from "../../toastify";

const legendStyle = {
  color: "rgba(0, 0, 0, 0.6)",
  fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
  fontWeight: 400,
  fontSize: "0.82rem",
  lineHeight: "1em",
  letterSpacing: "0.00938em",
};

const UpdateTrainingDatesDialog = ({
  loading,
  showDialog,
  setShowDialog,
  trainingRequest,
  updateTrainingDates
}) => {
  const request = trainingRequest?.request;
  const isOutsideCountry = request?.isTrainingInsideCountry === false || request?.isTrainingInsideCountry === "false";

  const [formData, setFormData] = useState({
    id: request?.id,
    trainingDurationFrom: request?.trainingDurationFrom || null,
    trainingDurationTo: request?.trainingDurationTo || null,
    departureDate: request?.departureDate || null,
    returningDate: request?.returningDate || null,
    bookingFlightDepartureDate:
      request?.bookingFlightDepartureDate || request?.trainingDurationFrom || null,
    bookingFlightArrivalDate:
      request?.bookingFlightArrivalDate || request?.trainingDurationTo || null,
  });

  const [errors, setErrors] = useState({
    trainingDurationFromHasError: false,
    trainingDurationToHasError: false,
    departureDateHasError: false,
    returningDateHasError: false,
    bookingFlightDepartureDateHasError: false,
    bookingFlightArrivalDateHasError: false,
  });

  const clearError = (field) =>
    setErrors((prev) => ({ ...prev, [field]: false }));

  const formValidator = () => {
    const error = {
      trainingDurationFromHasError: false,
      trainingDurationToHasError: false,
      departureDateHasError: false,
      returningDateHasError: false,
      bookingFlightDepartureDateHasError: false,
      bookingFlightArrivalDateHasError: false,
      hasError: false,
    };

    if (!formData.trainingDurationFrom) {
      error.trainingDurationFromHasError = true;
      error.hasError = true;
    }

    if (!formData.trainingDurationTo) {
      error.trainingDurationToHasError = true;
      error.hasError = true;
    } else if (
      formData.trainingDurationFrom &&
      new Date(formData.trainingDurationTo) < new Date(formData.trainingDurationFrom)
    ) {
      error.trainingDurationToHasError = true;
      error.hasError = true;
    }
 if (isOutsideCountry) {
    if (!formData.departureDate) {
      error.departureDateHasError = true;
      error.hasError = true;
    }

    if (!formData.returningDate) {
      error.returningDateHasError = true;
      error.hasError = true;
    } else if (( formData.departureDate &&
      new Date(formData.returningDate) < new Date(formData.departureDate))
    ) {
      error.returningDateHasError = true;
      error.hasError = true;
    }

   
      if (!formData.bookingFlightDepartureDate) {
        error.bookingFlightDepartureDateHasError = true;
        error.hasError = true;
      }

      if (!formData.bookingFlightArrivalDate) {
        error.bookingFlightArrivalDateHasError = true;
        error.hasError = true;
      } else if (
        formData.bookingFlightDepartureDate &&
        new Date(formData.bookingFlightArrivalDate) <
          new Date(formData.bookingFlightDepartureDate)
      ) {
        error.bookingFlightArrivalDateHasError = true;
        error.hasError = true;
      }
    }

    setErrors(error);

    if (error.hasError) {
      showError("Please fill out all required fields correctly");
      return true;
    }
    return false;
  };

  const onSave = () => {
    if (!formValidator()) {
      updateTrainingDates(formData, trainingRequest, onClose);
    }
  };

  const onClose = () => {
    setShowDialog(false);
  };

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="update-training-dates-title"
      open={showDialog}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle className="text-primary" id="update-training-dates-title">
        <Typography variant="overline" display="block">
          Update Training Dates
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <span className="material-icons">close</span>
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <fieldset className="form-group border p-2 mb-3">
            <legend className="w-auto px-2" style={legendStyle}>
              Training Duration
            </legend>
            <div className="row">
              <div className="col-md-6 mt-2">
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DesktopDatePicker
                    label="From *"
                    inputFormat="yyyy-MM-dd"
                    value={formData.trainingDurationFrom}
                    onChange={(date) => {
                      setFormData((prev) => ({
                        ...prev,
                        trainingDurationFrom: date,
                      }));
                      clearError("trainingDurationFromHasError");
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        size="small"
                        error={errors.trainingDurationFromHasError}
                        helperText={
                          errors.trainingDurationFromHasError ? "Required" : ""
                        }
                      />
                    )}
                  />
                </LocalizationProvider>
              </div>

              <div className="col-md-6 mt-2">
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DesktopDatePicker
                    label="To *"
                    inputFormat="yyyy-MM-dd"
                    value={formData.trainingDurationTo}
                    minDate={formData.trainingDurationFrom || undefined}
                    onChange={(date) => {
                      setFormData((prev) => ({
                        ...prev,
                        trainingDurationTo: date,
                      }));
                      clearError("trainingDurationToHasError");
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        size="small"
                        error={errors.trainingDurationToHasError}
                        helperText={
                          errors.trainingDurationToHasError
                            ? "Required or must be after From date"
                            : ""
                        }
                      />
                    )}
                  />
                </LocalizationProvider>
              </div>
    {isOutsideCountry && (
            <>
              <div className="col-md-6 mt-3">
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DesktopDatePicker
                    label="Departure Date *"
                    inputFormat="yyyy-MM-dd"
                    value={formData.departureDate}
                    onChange={(date) => {
                      setFormData((prev) => ({
                        ...prev,
                        departureDate: date,
                      }));
                      clearError("departureDateHasError");
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        size="small"
                        error={errors.departureDateHasError}
                        helperText={
                          errors.departureDateHasError ? "Required" : ""
                        }
                      />
                    )}
                  />
                </LocalizationProvider>
              </div>

              <div className="col-md-6 mt-3">
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DesktopDatePicker
                    label="Returning Date *"
                    inputFormat="yyyy-MM-dd"
                    value={formData.returningDate}
                    minDate={formData.departureDate || undefined}
                    onChange={(date) => {
                      setFormData((prev) => ({
                        ...prev,
                        returningDate: date,
                      }));
                      clearError("returningDateHasError");
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                        size="small"
                        error={errors.returningDateHasError}
                        helperText={
                          errors.returningDateHasError
                            ? "Required or must be after Departure date"
                            : ""
                        }
                      />
                    )}
                  />
                </LocalizationProvider>
              </div>
            </>
    )}
            </div>
          </fieldset>

          {isOutsideCountry && (
            <fieldset className="form-group border p-2">
              <legend className="w-auto px-2" style={legendStyle}>
                Booking Flight Dates
              </legend>
              <div className="row">
                <div className="col-md-6 mt-2">
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DesktopDatePicker
                      label="Flight Departure *"
                      inputFormat="yyyy-MM-dd"
                      value={formData.bookingFlightDepartureDate}
                      onChange={(date) => {
                        setFormData((prev) => ({
                          ...prev,
                          bookingFlightDepartureDate: date,
                        }));
                        clearError("bookingFlightDepartureDateHasError");
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          size="small"
                          error={errors.bookingFlightDepartureDateHasError}
                          helperText={
                            errors.bookingFlightDepartureDateHasError
                              ? "Required"
                              : ""
                          }
                        />
                      )}
                    />
                  </LocalizationProvider>
                </div>

                <div className="col-md-6 mt-2">
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DesktopDatePicker
                      label="Flight Arrival *"
                      inputFormat="yyyy-MM-dd"
                      value={formData.bookingFlightArrivalDate}
                      minDate={formData.bookingFlightDepartureDate || undefined}
                      onChange={(date) => {
                        setFormData((prev) => ({
                          ...prev,
                          bookingFlightArrivalDate: date,
                        }));
                        clearError("bookingFlightArrivalDateHasError");
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          size="small"
                          error={errors.bookingFlightArrivalDateHasError}
                          helperText={
                            errors.bookingFlightArrivalDateHasError
                              ? "Required or must be after Departure"
                              : ""
                          }
                        />
                      )}
                    />
                  </LocalizationProvider>
                </div>
              </div>
            </fieldset>
          )}
        </LocalizationProvider>
      </DialogContent>

      <DialogActions className="d-flex justify-content-center py-3">
        <button
          onClick={onSave}
          disabled={loading}
          className="btn btn-primary btn-sm px-4"
        >
          {loading ? "Saving..." : "Save"}
        </button>
        <button onClick={onClose} className="btn btn-secondary btn-sm px-4">
          Cancel
        </button>
      </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = ({ loading, trainingRequest }) => ({
  loading,
  trainingRequest,
});

export default connect(mapStateToProps, { updateTrainingDates })(
  UpdateTrainingDatesDialog
);
